import React, { useMemo } from 'react';
import moment from 'moment';

import { SetsPieChart } from '../../charts';

import { flowStepStatuses } from '../../../constants/enums';
import WarningIcon from '@material-ui/icons/ErrorOutline';
import CaseReportingIcon from '../../../assets/icons/CaseReportingIcon';

import { greenBorderColor, greyBorderColor, lightGreenColor, lightGreyColor } from '../../../utils/colors';

const { COMPLETED, PENDING } = flowStepStatuses;

const CaseFlowChart = (props) => {
  const { activeCase, steps } = props;

  const completed = useMemo(() => {
    return steps ? steps.filter((item) => item.status === COMPLETED.value) : [];
  }, [steps]);

  const pending = useMemo(() => {
    return steps ? steps.filter((item) => item.status === PENDING.value) : [];
  }, [steps]);

  const data = [
    { id: COMPLETED.label, label: COMPLETED.label, value: completed?.length, color: lightGreenColor, borderColor: greenBorderColor },
    { id: 'Remaining', label: 'Remaining', value: pending?.length, color: lightGreyColor, borderColor: greyBorderColor },
  ];

  const activeStep = useMemo(() => {
    const completed = steps?.filter((item) => item.status === flowStepStatuses.COMPLETED.value);
    const maxStep = Math.max(...completed.map(({ stepNumber }) => stepNumber));

    if (maxStep === steps?.length) {
      return steps[steps?.length - 1];
    }

    const step = steps?.find((item) => item.stepNumber === maxStep);
    const pending = steps?.find((item) => item?.stepNumber === step?.stepNumber + 1);

    if (pending) {
      return pending;
    } else {
      return steps?.find((item) => item?.stepNumber === 1);
    }
  }, [activeCase, steps]);

  const allCompleted = useMemo(() => {
    return steps?.every((allocation) => allocation.status === COMPLETED.value);
  }, [steps]);

  const dueDate = useMemo(() => moment(activeCase?.date).subtract(activeStep?.config?.dueDate, 'days'), [activeCase, activeStep]);
  const diff = useMemo(() => dueDate.diff(moment().startOf('day'), 'days'), [dueDate]);

  return (
    <div className='sets-chart__container' style={{ maxHeight: '277px' }}>
      <div className='sets-chart__chart flex-1'>
        <div className='d-flex p-l-lg m-b-md'>
          <CaseReportingIcon />
          <div className="font-size-bg font-bold m-l-md">
            Completed
          </div>
        </div>
        <SetsPieChart
          data={data}
          height='195px'
          margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
          padAngle={0}
          cornerRadius={0}
          transitionMode='endAngle'
        />
      </div>

      <div className='d-flex direction-column space-between align-end' style={{ maxWidth: '150px' }}>
        <div className='d-flex direction-column align-end width-100'>
          <div className='font-bold d-flex'>
            {diff >= 1 && (
              <div style={{ color: COMPLETED.color }}>
                {!allCompleted ? (
                  `Pending due in ${diff} day(s)`
                ) : (
                  'All Completed'
                )}
              </div>
            )}

            {!allCompleted && diff < 1 && (
              <div className='d-flex' style={{ color: flowStepStatuses.PENDING.color }}>
                <WarningIcon style={{ color: flowStepStatuses.PENDING.color, marginRight: 8 }} />
                <span className='font-bold'>Overdue</span>
              </div>
            )}
          </div>
          <div className=''>
            {!allCompleted && dueDate.format('Do MMMM')}
          </div>
        </div>
        <div className='sets-chart__legend'>
          <div>
            <div style={{ background: lightGreenColor, border: `1px solid ${greenBorderColor}` }} />
            <div>{COMPLETED.label}</div>
          </div>
          <div>
            <div style={{ background: lightGreyColor, border: `1px solid ${greyBorderColor}` }}  />
            <div>Remaining</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseFlowChart;
